module.exports = __webpack_public_path__ + "img/clock-light.33c2ec7f.svg";